import React, {useState,useEffect} from 'react';
import { XParagraph } from './XParagraph';
import { XQuote } from './XQuote';
// import { XRef } from './XRef';
import { XWords } from './XWords';
// import { XDiv } from './XDiv';
// import { DiWordpress } from 'react-icons/di';
// import {useNodes} from './NodeContext'
// import {Spinner} from "../Spinner/Spinner"

export interface MyComponentProps {
  // Define your prop types here
   nodes?: []
   paraNodes?: []
   index?: string
   selectedIndices?: any
   relatedSelectedIndices?: any
   commentAnnotationIndices?: any
   variantIndexListIndices?: any
   ftype?: string // indicates if the text is secondary as "secondary"; defaulty or undefined means "primary"
   startParagraph?: number
   endParagraph?: number
}

export const XText: React.FC<MyComponentProps> = (props) => {
  //const dataTest = useNodes();
  const paraNodes = props.paraNodes
  
  
  const keyPrefix = props.ftype === "secondary" ? "sec-" : ""
  const startsWithPunctuation = (s: string): boolean => {
    // This regex matches if the string starts with common punctuation characters
    const regex = /^[!.,;:?\"]/;
    return regex.test(s);
  }

  const displayText = () => {
    if (props.nodes ){
      const target: any = props.nodes
      let paragraphCounter: number = 0;
      const dataArray = target["child-nodes"].map((d: any, idx: number) => {
          const keys: any[] = []
          const dupKeys: any[] = []
          const key = "k-" + keyPrefix + props.index + "-" + idx;
          if (dupKeys.includes(key)){
            console.log("duplicate key", key)
          }
          else{
            keys.push(key)
          }
          
          if (d["node-name"] === "p"){
            paragraphCounter++;
            const sctaid = "http://scta.info/resource/" + d.attributes.find((a: any) => a.name === "xml:id")?.value;
            return (<XParagraph key={"p-" + sctaid} number={paragraphCounter} nodes={d} id={sctaid} startParagraph={props.startParagraph} endParagraph={props.endParagraph}/>)
          }
          else if (d["node-name"] === "div"){
            const sctaid = "http://scta.info/resource/" + d.attributes.find((a: any) => a.name === "xml:id")?.value;
            // return (<XDiv key={key} nodes={d} id={sctaid}/>)
            return (<XText key={key} nodes={d} startParagraph={props.startParagraph} endParagraph={props.endParagraph}/>)
          }
          else if (d["node-name"] === "head"){
            // return (<h1 key={key}>
            //   <XText nodes={d} index={key}/>
            // </h1>)
          }
          else if (d["node-name"] === "quote"){
            const sctaid = "http://scta.info/resource/" + d.attributes.find((a: any) => a.name === "xml:id")?.value;
            return (<XQuote key={key} nodes={d} id={sctaid} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/> )
          }
          else if (d["node-name"] === "app"){
            return <XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/>
          }
          else if (d["node-name"] === "lem"){
            return <XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/>
          }
          else if (d["node-name"] === "mentioned"){
            return <><span data-type='punctuation'>'</span><XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/><span data-type='punctuation'>'</span></>
          }
          else if (d["node-name"] === "ref"){
            const sctaid = "http://scta.info/resource/" + d.attributes.find((a: any) => a.name === "xml:id")?.value;
            return (<XQuote key={key} nodes={d} id={sctaid} type="ref" selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/> )
            
          }
          else if (d["node-name"] === "lb" && d.attributes.find((a: any) => a.name === "break")?.value){
            return <>-<br/><span> {d.attributes.find((a: any) => a.name === "n")?.value} </span></>
          }
          else if (d["node-name"] === "lb"){
            return <><br/><span> {d.attributes.find((a: any) => a.name === "n")?.value} </span></>
          }
          else if (d["node-name"] === "name"){
            return <XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/>
          }
          else if (d["node-name"] === "title"){
            return <XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/>
          }
          else if (d["node-name"] === "cit"){
            return <XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/>
          }
          else if
          (d["node-name"] === "seg" && d.attributes.find((a: any) => a.name === "type")?.value === "navigation"){
            return <span style={{"fontVariant": "small-caps", "letterSpacing": "0.05em;", "fontWeight": "bold"}}><XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/></span>

          }

          else if (d["node-name"] === "supplied" || d["node-name"] === "seg" || d["node-name"] === "corr" || d["node-name"] === "sic" || d["node-name"] === "unclear" || d["node-name"] === "q" || d["node-name"] === "reg" || d["node-name"] === "choice"){
            return <XText key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/>
          }
          else if (d["node-type"] === "text"){
            return <XWords key={key} nodes={d} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index + "-" + idx} ftype={props.ftype}/>
            // return <span>{d["value"]}</span>
        }
      })
      return dataArray
    }
    else {
      return null
    }
  }
  
  
  
  return (
    <>
    {displayText()}
    </>
    )
  
}